import { villagesApi } from '../api/modules/villages.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { villageMasterSeed } from '../data/master/villages';
import { mapPaginated, villageFromApi, villageToApi } from '../models';
import { clearVillagesLookupCache } from './lookup.repository';

export async function listVillages(params = {}) {
  if (!USE_API) {
    let items = [...villageMasterSeed];
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (v) =>
          v.villageName?.toLowerCase().includes(q) ||
          v.villageId?.toLowerCase().includes(q) ||
          v.pin?.includes(q),
      );
    }
    if (params.isActive === true) items = items.filter((v) => v.active);
    if (params.isActive === false) items = items.filter((v) => !v.active);
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 10;
    const start = (page - 1) * pageSize;
    return {
      items: items.slice(start, start + pageSize),
      total: items.length,
      page,
      pageSize,
    };
  }
  try {
    const result = await villagesApi.list(params);
    return mapPaginated(result, villageFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load villages'));
  }
}

export async function getVillage(id) {
  if (!USE_API) {
    return villageMasterSeed.find((v) => v.villageId === id) || null;
  }
  try {
    const row = await villagesApi.getById(id);
    return villageFromApi(row);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load village'));
  }
}

export async function createVillage(ui) {
  if (!USE_API) {
    throw new Error('Create village requires API mode');
  }
  try {
    const row = await villagesApi.create(villageToApi(ui));
    clearVillagesLookupCache();
    return villageFromApi(row);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create village'));
  }
}

export async function updateVillage(id, ui) {
  if (!USE_API) {
    throw new Error('Update village requires API mode');
  }
  try {
    const row = await villagesApi.update(id, villageToApi(ui));
    clearVillagesLookupCache();
    return villageFromApi(row);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update village'));
  }
}

export async function deleteVillage(id) {
  if (!USE_API) {
    throw new Error('Delete village requires API mode');
  }
  try {
    await villagesApi.remove(id);
    clearVillagesLookupCache();
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete village'));
  }
}
